<template>
  <div class="main-product__details">
    <!-- USP -->
    <main-product-sidebar-usp
      :blocks="usp"
      :content="uspContent"
    />

    <!-- Accordions -->
    <div v-if="liquid.type != 'sawmill'"
      class="main-product__accordions"
    >
      <!-- Tech specs -->
      <div
        v-if="techSpecs.length > 0"
        class="main-product__accordion"
      >
        <btn
          class="main-product__accordion-button"
          class-label="main-product__accordion-label text-heading-m"
          :label="$string('product.sidebar.specs')"
          modifiers="text"
          show-icon
          @click="toggleAccordion($string('product.sidebar.specs'))"
        >
          <template #icon>
            <icon-minus v-if="isActive($string('product.sidebar.specs'))" />

            <icon-plus v-else />
          </template>
        </btn>

        <transition-height>
          <div
            v-show="isActive($string('product.sidebar.specs'))"
            class="main-product__accordion-content text-body-s-regular"
          >
            <template
              v-for="(spec, index) of techSpecs"
            >
              <product-stat
                v-if="product[spec.value] || liquid[spec.value]"
                :key="index"
                :label="spec.label"
                label-class="text-body-l-regular"
                :value="product[spec.value] || liquid[spec.value]"
                :unit="spec.unit"
                :desc="product[spec.desc] || liquid[spec.desc]"
              />
            </template>
          </div>
        </transition-height>
      </div>

      <!-- RTE -->
      <template
        v-for="(accordion, index) of mainAccordion"
        :key="index"
      >
        <div
          v-if="
            (accordion.content === 'needHelp' && needHelp) ||
              product[accordion.content] || liquid[accordion.content]
          "
          class="main-product__accordion"
        >
          <btn
            class="main-product__accordion-button"
            class-label="main-product__accordion-label text-heading-m"
            :label="accordion.label"
            modifiers="text"
            show-icon
            @click="toggleAccordion(accordion.label)"
          >
            <template #icon>
              <icon-minus v-if="isActive(accordion.label)" />

              <icon-plus v-else />
            </template>
          </btn>

          <transition-height>
            <div
              v-show="isActive(accordion.label)"
              class="main-product__accordion-content text-body-s-regular"
            >
             <div
                v-if="
                  (accordion.content === 'needHelp' && needHelp) ||
                    product[accordion.content] || liquid[accordion.content]
                "
                class="rte"
                 v-html="accordion.content === 'needHelp'
    ? sanitizeContent(needHelp)
    : sanitizeContent(product[accordion.content] || liquid[accordion.content])"
              />
            </div>
          </transition-height>
        </div>
      </template>

      <!-- Additional Accordions -->
      <template
        v-for="(accordion, index) of additionalAccordion"
        :key="index"
      >
        <div
          v-if="accordion.title && accordion.content"
          class="main-product__accordion"
        >
          <btn
            class="main-product__accordion-button"
            class-label="main-product__accordion-label text-heading-m"
            :label="accordion.title"
            modifiers="text"
            show-icon
            @click="toggleAccordion(accordion.title)"
          >
            <template #icon>
              <icon-minus v-if="isActive(accordion.title)" />

              <icon-plus v-else />
            </template>
          </btn>

          <transition-height>
            <div
              v-show="isActive(accordion.title)"
              class="main-product__accordion-content rte"
              v-html="accordion.content"
            />
          </transition-height>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import MainProductSidebarUsp from './main-product-sidebar-usp'
import TransitionHeight from '~async/transition-height/transition-height'
import Btn from '~global/btn/btn'
import IconMinus from '~icons/directional-navigation/minus.svg'
import IconPlus from '~icons/directional-navigation/plus.svg'
import ProductStat from '~global/product-stat/product-stat'

export default {
  name: 'MainProductSidebarDetails',
  components: {
    TransitionHeight,
    Btn,
    MainProductSidebarUsp,
    IconMinus,
    IconPlus,
    ProductStat,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    needHelp: {
      type: String,
      default: '',
    },
    globalContact: {
      type: String,
      default: '',
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    usp: {
      type: [Array],
      default: () => {
        return []
      },
    },
  },

  data() {
    return {
      activeAccordion: this.$string('product.sidebar.description'),
      techSpecsData: [
        {
          label: this.$string('compare.log_diameter'),
          value: 'logDiameter',
          unit: this.$string('compare.log_diameter_unit'),
          desc: 'logDiameterTooltip',
        },
        {
          label: this.$string('compare.width_of_cut'),
          value: 'widthOfCut',
          unit: this.$string('compare.width_of_cut_unit'),
          desc: 'boardWidthTooltip',
        },

        {
          label: this.$string('compare.max_horsepower'),
          value: 'maxHorsepower',
          unit: this.$string('compare.max_horsepower_unit'),
          desc: 'maxHorsepowerTooltip',
        },
      ],
      mainAccordion: [
        {
          label: this.$string('product.sidebar.description'),
          content: 'description',
        },
        {
          label: this.$string('product.sidebar.included'),
          content: 'included',
        },
        {
          label: this.$string('product.sidebar.need_help'),
          content: 'needHelp',
        },
      ],
    }
  },

  computed: {

    /**
     * Compute usp content.
     */
    uspContent() {
      const shipsIn = this.$string('product.sidebar.ships_in')
      const usp = {

        lead_time: cnvs?.store?.country?.toLowerCase() === 'us'
        ? (this.variant.leadTime ? `${shipsIn}${this.variant.leadTime}` : false)
        : cnvs?.store?.country?.toLowerCase() === 'ca'
          ? (this.variant.leadTimeCA ? `${shipsIn}${this.variant.leadTimeCA}` : false)
          : false,

        
        leadTimeIcon: this.variant.leadTimeIcon ? `https:${this.variant.leadTimeIcon}` : false,
        financing: this.product.financing || this.product.financing,
        warranty: this.product.warranty || this.liquid.warranty,
      }
      return usp
    },

    /**
     * Compute tech specs.
     */
    techSpecs() {
      const techSpecs = []

      this.techSpecsData.forEach((spec) => {
        if (this.product[spec.value] || this.liquid[spec.value]) {
          techSpecs.push(spec)
        }
      })

      return techSpecs
    },

    /**
     * Compute additional accordion.
     * - Parses a single richtext string into an array of objects that will
     * be used to render multiple separate accordions.
     */
    additionalAccordion() {
      const accordionObjects = []
      // eslint-disable-next-line prefer-named-capture-group
      const regex = /<h(\d)>(.*?)<\/h\1>(.*?)?(?=<h\d>|<\/div>)/gs
      let match
      while ((match = regex.exec(this.liquid.additionalAccordions)) !== null) {
        const title = match[2]
        const content = match[3]
        accordionObjects.push({ title, content })
      }

      return accordionObjects
    },
  },

  mounted() {
    // not empty
  },

  methods: {

    /**
     * Check if an accordion is active.
     * @param {String} target - label of accordion.
     */
    isActive(target) {
      return this.activeAccordion === target
    },
sanitizeContent(content) {
    if (!content) return '';
    return content.replace(/\b\d{1}-\d{3}-\d{3}-\d{4}\b/g, this.globalContact);
  },
    /**
     * Toggle active accordion.
     * @param {Number} targetIndex -  Index of an accordion.
     */
    toggleAccordion(target) {
      if (target === this.activeAccordion) {
        this.activeAccordion = null
        return
      }

      this.activeAccordion = target
    },
  },
}
</script>
